import { render, staticRenderFns } from "./FullVideoComponent.vue?vue&type=template&id=34b8f6f0&"
import script from "./FullVideoComponent.vue?vue&type=script&lang=ts&"
export * from "./FullVideoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports